import { render, staticRenderFns } from "./ProvideCard.vue?vue&type=template&id=0a011212&"
import script from "./ProvideCard.vue?vue&type=script&lang=js&"
export * from "./ProvideCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports